import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, InputGroup } from "react-bootstrap";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
const url = apiEndPoint + "/PoSDbyLoB/?key=";
const PointOfService = ({ formInputData, handleInputChange }) => {
  const [setLoaderActive] = useContext(AppContext);
  const [posds, setPosds] = useState([]);
  const fetchPosds = async () => {
    if (formInputData.lob_id === "") {
      setPosds([]);
      return true;
    }
    try {
      setLoaderActive(true);
      const posd = await fetch(url + formInputData.lob_id).then((response) =>
        response.json()
      );
      if (posd.success) {
        setLoaderActive(false);
        setPosds(posd.response);
      }
    } catch (error) {
      setLoaderActive(false);
      console.log(error);
    }
  };
  useEffect(() => {
    fetchPosds();
  }, [formInputData.lob_id]);
  if (posds.length === 0) {
    return <></>;
  }
  return (
    <fieldset>
      <legend>Business Point of Services</legend>
      <Card className="mb-3">
        <Card.Header as="h5">Point of Services</Card.Header>
        <Card.Body>
          <Row sm={2} md={3} lg={4} xs={2}>
            {posds.map((posd) => {
              let checked = formInputData.posds.includes(
                posd.point_of_service_delivery_id.toString()
              );
              return (
                <Col
                  key={posd.point_of_service_delivery_id}
                  className="mb-3 d-flex justify-content-center"
                >
                  <Form.Group>
                    <InputGroup>
                      <input
                        type="checkbox"
                        className="btn-check"
                        value={posd.point_of_service_delivery_id}
                        checked={formInputData.posds.includes(
                          posd.point_of_service_delivery_id.toString()
                        )}
                        onChange={handleInputChange}
                        name="posd"
                        id={`posd_${posd.point_of_service_delivery_id}`}
                      />
                      <label
                        className={`btn btn-outline-primary ${
                          checked ? "" : "rounded"
                        }`}
                        htmlFor={`posd_${posd.point_of_service_delivery_id}`}
                      >
                        {posd.point_of_service_delivery_name}
                      </label>
                      {/* {checked && <Form.Control htmlSize="2" autoFocus />} */}
                    </InputGroup>
                  </Form.Group>
                </Col>
              );
            })}
          </Row>
        </Card.Body>
      </Card>
    </fieldset>
  );
};

export default PointOfService;
